<template>
  <v-text-field
    ref="campo"
    v-model="model"
    v-bind="attrs"
    :label="labelDefault"
    :rules="rules"
    v-on="$listeners"
    :data-cy="attrs.label || attrs.name"
  >
    <template v-for="(_, slotName) in $scopedSlots" v-slot:[slotName]="context">
      <slot :name="slotName" v-bind="context" />
    </template>
    <template v-for="(_, name) in $slots" v-slot:[name]>
      <slot :name="name" />
    </template>
    <template v-if="!$scopedSlots.message" v-slot:message="{ message, key }">
      <v-icon v-if="$api.UI.showErrorIcon($el)" x-small color="error" class="mr-1 pb-1">{{$theme.options.iconError}}</v-icon>
      <span v-html="message" :key="key"></span>
    </template>
  </v-text-field>
</template>
<script>
export default {
  props: {
    value: [String, Number],
    allowSpecialChars: { type: Boolean, default: false },
    allowAnyCelFirstDigit: { type: Boolean, default: false }
  },
  computed: {
    toUpperCase: function () {
      if (this.$attrs['upper-case'] === false) return false
      return localStorage.upperCaseForm === 'S' || (this.$attrs['upper-case'] || this.$attrs['upper-case'] === '')
    },
    labelDefault: function () {
      return (
        this.$attrs.label ? this.$attrs.label +
        (this.$attrs.required === '' || this.$attrs.required === true ? ' *' : '')
          : ''
      )
    },
    model: {
      get () {
        if (this.toUpperCase && this.value && this.$el && !['numeric', 'datetext', 'fone', 'tel', 'cel'].some(p => p === this.$attrs.format) && !['password', 'numeric', 'datetext'].some(p => p === this.$attrs.type) && typeof this.value === 'string') {
          var input = this.$el.querySelector('input')
          const p = input.selectionStart
          this.$nextTick(() => {
            const type = input.type
            if (type !== 'email') {
              input.type = 'text'
              input.setSelectionRange(p, p);
              input.type = type
            }
          })
          return this.value.toUpperCase()
        }
        return this.value
      },
      set (value) {
        if (value && typeof value === 'string') { this.$emit('input', this.toUpperCase ? value.toUpperCase() : value) } else { this.$emit('input', value) }
      }
    },
    attrs () {
      return { ...this.$theme.options, ...this.$theme.options.text, ...this.$attrs }
    },
    rules () {
      const errors = []
      const name = this.$attrs.name || this.$attrs.label || ''
      if (this.$attrs.required === '' || this.$attrs.required === true) {
        !!this.model || errors.push(name + ' é obrigatório.')
      }

      if (this.$attrs.counter) {
        (this.model ? this.model : '').toString().length <=
          this.$attrs.counter ||
          errors.push(
            name + ' deve ter até ' + this.$attrs.counter + ' caracteres.'
          )
      }

      this.$api.UTIL.Functions.ValidateFormRules(this.$attrs.rules, errors)

      if (this.model) {
        const notvalidText = ' informado não é válido.'
        if (this.$attrs.format === 'bmpemail') {
          // eslint-disable-next-line
          /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(
            this.model
          ) || errors.push(name + notvalidText);

          /^[^\u00C0-\u017F]*$/.test(this.model) || errors.push(name + ' não permite caracteres especias');
        } else if (this.$attrs.format === 'phone') {
          // eslint-disable-next-line
          /(?:\()[0-9]{2}(?:\))\s?[0-9]{4,5}(?:-)[0-9]{4}$/i.test(this.model) ||
            errors.push(name + notvalidText)

          // eslint-disable-next-line
          if (!this.allowAnyCelFirstDigit && /(?:\()[0-9]{2}(?:\))\s?[0-9]{5}(?:-)[0-9]{4}$/i.test(this.model)) {
            const regex = /(?:\()[0-9]{2}(?:\))\s?[6-9]{1}/;
            if (!regex.test(this.model)) {
              errors.push(name + ': O número de celular deve iniciar com 6, 7, 8 ou 9.')
            }
          }
        } else if (this.$attrs.format === 'tel') {
          // eslint-disable-next-line
          /(?:\()[0-9]{2}(?:\))\s?[0-9]{4}(?:-)[0-9]{4}$/i.test(this.model) ||
            errors.push(name + notvalidText)
        } else if (this.$attrs.format === 'cel') {
          // eslint-disable-next-line
          /(?:\()[0-9]{2}(?:\))\s?[0-9]{5}(?:-)[0-9]{4}$/i.test(this.model) ||
            errors.push(name + notvalidText)

          if (!this.allowAnyCelFirstDigit) {
            const regex = /(?:\()[0-9]{2}(?:\))\s?[6-9]{1}/;
            if (!regex.test(this.model)) {
              errors.push(name + ': O número de celular deve iniciar com 6, 7, 8 ou 9.')
            }
          }
        } else if (this.$attrs.format === 'cep') {
          // eslint-disable-next-line
          /[0-9]{2}\.?[0-9]{3}\-?[0-9]{3}$/i.test(this.model) ||
            errors.push(name + notvalidText)
        } else if (this.$attrs.format === 'doc') {
          // eslint-disable-next-line
          /(^\d{3}\.\d{3}\.\d{3}\-\d{2}$)|(^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$)/i.test(
            this.model
          ) || errors.push(name + notvalidText)
        } else if (this.$attrs.format === 'cpf') {
          // eslint-disable-next-line
          /^\d{3}\.\d{3}\.\d{3}\-\d{2}$/i.test(this.model) ||
            errors.push(name + notvalidText)
        } else if (this.$attrs.format === 'cnpj') {
          // eslint-disable-next-line
          /^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$/i.test(this.model) ||
            errors.push(name + notvalidText)
        } else if (this.$attrs.format === 'bmptime') {
          if (this.$parent.mask === '##:##') {
          // eslint-disable-next-line
            /^(?:\d|[01]\d|2[0-3]):[0-5]\d$/i.test(this.model) || errors.push(name + notvalidText)
          }
          if (this.$parent.mask === '##:##:##') {
          // eslint-disable-next-line
            /^(?:\d|[01]\d|2[0-3]):[0-5]\d:[0-5]\d$/i.test(this.model) || errors.push(name + notvalidText) 
          }
        } else if (this.$attrs.format === 'datetext') {
          // eslint-disable-next-line
         let test = /^(0[1-9]|[12][0-9]|3[01])[- \/.](0[1-9]|1[012])[- \/.](19|20)\d\d$/i.test(this.model) 
          if (!test || !this.$api.UI.Date.IsValid(this.model)) {
            errors.push(name + notvalidText)
          } else {
            if (this.$attrs.max && this.$api.UI.Date.DaysBetween(this.$attrs.max, this.$api.UI.Parse.Date(this.model)) > 0) {
              errors.push(name + ' máxima permitida é ' + this.$api.UI.Format.Date(this.$attrs.max) + '.')
            }
          }
        } else if (this.$attrs.format === 'numeric' && (this.$attrs.max || this.$attrs.min)) {
          try {
            if (this.$attrs.max || this.$attrs.max === 0) {
              const max = parseFloat(this.$attrs.max)
              const val = this.$api.UI.Parse.Decimal(this.value, this.$attrs.precision)
              if (val > max) {
                errors.push(
                  'Valor Máximo permitido é ' + this.$api.UI.Format.Decimal(max, (!this.$attrs.format ? 0 : 2) + '.')
                )
              }
            }

            if (this.$attrs.min || this.$attrs.min === 0) {
              const min = parseFloat(this.$attrs.min)
              const val = this.$api.UI.Parse.Decimal(this.value, this.$attrs.precision)
              if (val < min) {
                errors.push(
                  'Valor Mínimo permitido é ' + this.$api.UI.Format.Decimal(min, (!this.$attrs.format ? 0 : 2) + '.')
                )
              }
            }
          } catch {
            // ignora
          }
        } else {
          if (this.$refs && this.$refs.campo && this.$refs.campo.$el) {
            if (this.$refs.campo.$el.hasAttribute('data-mask')) {
              var mask = this.$refs.campo.$el.getAttribute('data-mask')
              if (typeof mask === 'string' && mask.includes(',')) { mask = mask.split(',') }
              if (Array.isArray(mask)) {
                if (!mask.some(element => element.length === this.model.length)) {
                  errors.push(name + notvalidText)
                }
              } else {
                if (mask.length !== this.model.length) {
                  errors.push(name + notvalidText)
                }
              }
            }
          }
        }

        if (
          this.$attrs.format === 'doc' ||
          this.$attrs.format === 'cpf' ||
          this.$attrs.format === 'cnpj'
        ) {
          if (this.$attrs['documento-invalido'] === true) {
            errors.push(name + notvalidText)
          }
        }
        if (this.$attrs.format === 'cep') {
          if (this.$attrs['cep-invalido'] === true) {
            errors.push(name + notvalidText)
          }
        }
        if (!this.$attrs.format &&
            this.$attrs.type !== 'password' &&
            !this.allowSpecialChars &&
            (!this.$attrs.disabled && this.$attrs.disabled !== '') &&
            (!this.$attrs.readonly && this.$attrs.readonly !== '') &&
            (!this.$attrs.type || this.$attrs.type === 'text') &&
            this.$refs && this.$refs.campo && this.$refs.campo.$el &&
            !this.$refs.campo.$el.getAttribute('data-mask')
        ) {
          const regex = /^[A-zà-úÀ-Ú0-9&'\s\-.]+$/gm;
          if (!regex.test(this.model)) {
            errors.push(name + ' não permite caracteres especiais.')
          }
        }
      }

      if (this.$refs && this.$refs.campo && this.$refs.campo.$el) {
        this.$refs.campo.$el.setAttribute(
          'data-message',
          errors ? errors[0] : ''
        )
        this.$refs.campo.$el.setAttribute('data-invalid', errors.length > 0)
      }

      return errors
    }
  },
  mounted () {
    this.$nextTick(function () {
      const errors = this.rules
      this.$el.setAttribute('data-message', errors ? errors[0] : '')
      this.$el.setAttribute('data-invalid', errors.length > 0)
    })
  }
}
</script>
